import { Description as DescriptionField } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

import { useUpdateEventTypeMutation } from '../../../../api'

export const Description = ({ isLocked }) => {
  const { id } = useEventType()
  const [, { isLoading }] = useUpdateEventTypeMutation({ id })

  return (
    <DescriptionField
      hideLabel
      disabled={isLoading}
      eventTypeId={id}
      isLocked={isLocked}
    />
  )
}
